module.exports = __webpack_public_path__ + "static/img/tab1spic.2bf1dcf4.png";